import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from 'beam'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

export interface UnsavedChangesDialogProps {
  onYes: () => void,
  onNo: () => void,
  open: boolean,
}

const UnsavedChangesDialog: FC<UnsavedChangesDialogProps> = ({ onYes, onNo, open }) => {
  const { t } = useTranslation()
  return (
    <Dialog open={open}>
      <DialogTitle>{t('warning')}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t('unsaveChange')}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onYes} color="primary" data-testid="UnsavedChanges-Yes">
          {t('yes')}
        </Button>
        <Button onClick={onNo} variant="text" color="default" data-testid="UnsavedChanges-No">
          {t('no')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default UnsavedChangesDialog
